module.exports = __webpack_public_path__ + "img/thumb_2020-05.315e8e42.jpg";